import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import MESSAGES from '../messages';

const CookieHeader = ({showConfigOptions = false}) => {
  const title = showConfigOptions ? MESSAGES.MANAGEMENT_TITLE : MESSAGES.DESCRIPTION_TITLE;

  return <FormattedMessage {...title} />;
};

CookieHeader.displayName = 'CookieModalHeader';

CookieHeader.propTypes = {
  /**
   * Set title modal.
   */
  showConfigOptions: PropTypes.bool,
};

export default CookieHeader;
